export default __webpack_public_path__ + "images/error.v-a7bd795fc8ceb3f1c5dcc2e66baabac9.svg";